import Head from 'next/head'
import { Fragment } from 'react'

type DefaultHeaderProps = {
  title?: string
  allowZoom?: boolean
}

export const DefaultHeader = ({
  title,
  allowZoom = false,
}: DefaultHeaderProps) => {
  return (
    <Fragment>
      <Head>
        <title>{title || ''}</title>
        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE-Edge" />
        {!allowZoom && (
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          />
        )}
      </Head>
    </Fragment>
  )
}
